import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'mileageExcelExport';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const mileageReimbursementExcelExportActions = { ...slice.actions, ...extraActions };
export const mileageReimbursementExcelExportReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        mileageExcelExport: {},
        //dashboardArgs: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/MileageReimbursement`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async (postData)  => await fetchWrapper.post(`${baseUrl}/ExportToExcel`, {postData})
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.mileageExcelExport = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.mileageExcelExport = action.payload;
                // state.dashboardArgs = action.meta.arg;                
            },
            [rejected]: (state, action) => {
                state.mileageExcelExport = { error: action.error };
            }
        };
    }
}
